import Avatar from "./reusable/Avatar";
import EmptyState from "./reusable/EmptyState";
import { ChatDotsFill } from "react-bootstrap-icons";

const CommentList = ({ comments }) => {
  if (!comments?.length) {
    return <EmptyState icon={ChatDotsFill} description="No comments yet" />;
  }

  return (
    <div className="d-flex flex-column gap-2 mt-2">
      {comments.map((element) => (
        <div key={element._id} className="comment-item">
          <Avatar size="xs" />
          <div>
            <div className="comment-bubble">
              <div className="comment-author">
                {element.commentBy.split("@")[0]}
              </div>
              <div className="comment-text">{element.commentBody}</div>
            </div>
            <div className="comment-date">{element.commentDate}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CommentList;
